// extracted by mini-css-extract-plugin
export default {"label":"ArchitectureLabel_label__XdAwu"};